import { TMcsaWorldKey } from '../types/mcsa.interface';

export const MCSA_WORLD_THEME: Record<TMcsaWorldKey, { accent: string; accent2: string }> = {
    cur: { accent: '#5E7CA6', accent2: '#8FB0D6' },
    travel: { accent: '#CE7A4B', accent2: '#3FA6A0' },
    shop: { accent: '#D6489B', accent2: '#F0B429' },
    hobby: { accent: '#B5731E', accent2: '#C0552F' },
    mingle: { accent: '#D9557A', accent2: '#B98CE0' },
    online: { accent: '#5B6FC9', accent2: '#3FA6A0' },
};
